import { useState } from "react";

const useGoogleOptimize = () => {
  const [loading, setLoading] = useState(true);
  const [testValue, setTestValue] = useState(null);

  const loadTest = (testName) => {
    if (window.GO) {
      setTestValue(window.GO[testName]);
      setLoading(false);
    } else {
      const waitForGO = () => {
        document.removeEventListener("GO:done", waitForGO);
        setTestValue(window.GO[testName]);
        setLoading(false);
      };
      document.addEventListener("GO:done", waitForGO);
    }
  };

  return {
    loading,
    loadTest,
    testValue,
  };
};

export default useGoogleOptimize;
